import React from 'react';
import { Link } from 'react-router-dom';

import SeriesList from 'rebook/apps/catalog/components/SeriesList';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const SearchSeriesList = ({ seriesList, seriesCount, query }) => (
  <div className={styles.section}>
    <div className="title-1">Серии</div>
    {seriesCount > 6 && (
      <Link className="cy-search-all-series"
        to={{
          pathname: `/search/series/`,
          state: { seriesList, seriesCount, query },
          search: `?q=${query}` }}>
        <div className="link">
          {seriesCount} {pluralize(seriesCount, 'серия', 'серии', 'серий')}
        </div>
      </Link>
    )}
    <div className={styles.content}>
      <SeriesList series={seriesList.slice(0, 4)} />
    </div>
  </div>
);

export default SearchSeriesList;
